<template>
  <div>
    <div v-if="loading" class="loader">
      <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>
    </div>
    <div v-else class="px-3 board-header">
      <div class="col-12" style="padding: 0px 10px;">
        <h4>{{ reportTitle }}</h4>
        Prévia dos Índices de Satisfação
      </div>
      <div class="row mt-4">
        <b-table
          id="table-index-preview"
          striped
          :items="items"
          :fields="fields"
        >
          <template v-if="this.totalVendas" v-slot:cell(satisfacao)="row">
            <div>{{ row.item.satisfacao }} %</div>
          </template>
          <template v-else v-slot:cell(satisfacao)="row">
            <div>{{ row.item.satisfacao }}</div>
          </template>
          <template v-slot:cell(testDrive)="row">
            <div>{{ row.item.testDrive }} %</div>
          </template>
          <template v-slot:cell(frft)="row">
            <div>{{ row.item.frft }} %</div>
          </template>
        </b-table>
      </div>
      <div class="col-12 mt-2 text-right">
        <a @click="exportToXLS" title="Exportar para XLS">
          <span class="xls">
            <i class="fas fa-file-excel"></i>
          </span>
        </a>
      </div>
      <!--
      <div class="row">
        <div class="mt-4 mb-4">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalVendas + totalPosvendas"
            :per-page="10"
            aria-controls="table-index-preview"
          ></b-pagination>
        </div>
      </div>
      -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';
import loader from '@/components/atoms/loader';
import api from '../../../../services/api';
import XLSX from 'xlsx';

export default {
  name: 'IndexPreview',
  components: {
    loader,
  },

  data: () => ({
    loading: false,
    userAuth: null,
    fields: [],
    items: [],
    totalVendas: 0,
    totalPosvendas: 0,
    currentPage: 1,
    reportTitle: '',
    indexLabel: '',
  }),

  computed: {
    ...mapState('authentication', ['userProfile']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getIndexPreview();
    },

    myActionId: function watchmyActionId() {
      this.getIndexPreview();
    },

    myActionsIds: function watchmyActionsIds() {
      this.getIndexPreview();
    },

    calendarDates: function watchCalendarDates() {
      this.getIndexPreview();
    },

    myIh1: function watchMyIh1() {
      this.getIndexPreview();
    },

    myHierarchies1: function watchMyHierarchies1(){
      this.getIndexPreview();
    },

    myIh2: function watchMyIh2() {
      this.getIndexPreview();
    },

    myHierarchies2: function watchMyHierarchies2(){
      this.getIndexPreview();
    },

    myMetric: function watchMyMetric() {
      this.getIndexPreview();
    },

    'indicatorData.value': function watchIndicatorDataValue() {
      this.getIndexPreview();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getIndexPreview();
    },
  },

  methods: {
    async getIndexPreview() {
      this.loading = true;
      this.totalVendas = 0;
      this.totalPosvendas = 0;
      this.items = [];

      if(this.actionGroupData && this.actionGroupData.name ==='Sem classificação'){
        this.items = [];
        this.loading = false;
        return
      }

      const response = await api.get('/reports/indexpreview', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start,
          endDate: this.calendarDates.end,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });

      if (response) {
        this.items = [];
        this.totalVendas = response.data[0].vendas.entrevistas;
        this.totalPosvendas = response.data[0].posvendas.entrevistas;

        response.data.forEach(async (data) => {
        if (data.vendas.entrevistas > 0) {
          await this.items.push({
            codigo: data.vendas.codigo,
            concessionaria: data.concessionaria,
            cota: data.vendas.cotaMinima,
            entrevistas: data.vendas.entrevistas,
            satisfacao: data.vendas.satisfacaoVeiculo.totalSatisfacao,
            index: this.calculateIndex(data.vendas),
            nps: data.vendas.nps.totalNps,
            recomendacao: data.vendas.recomendacao.totalRecomendacao,
            testDrive: data.vendas.ofertaTestDrive.totalTestDrive,
          });
          this.fields[4].label = 'Satisfação com o Veículo (%SIM)';
          this.fields[8].key = 'testDrive';
          this.fields[8].label = 'Oferta Test Drive (%SIM)';
        }
        if (data.posvendas.entrevistas > 0) {
          await this.items.push({
            codigo: data.posvendas.codigo,
            concessionaria: data.concessionaria,
            cota: data.posvendas.cotaMinima,
            entrevistas: data.posvendas.entrevistas,
            satisfacao: data.posvendas.satisfacaoGeral.totalSatisfacao,
            index: this.calculateIndex(data.posvendas),
            nps: data.posvendas.nps.totalNps,
            recomendacao: data.posvendas.recomendacao.totalRecomendacao,
            frft: data.posvendas.frft.totalFrft,
          });
          this.fields[4].label = 'Satisfação Geral';
          this.fields[8].key = 'frft';
          this.fields[8].label = 'FRFT (% não)';
        }
      });

      }

      this.loading = false;
    },
    calculateIndex(obj) {
      let total = 0;
      let reportIndex;
      if (this.userAuth.companyId === '6107f837f50c776b205ebf48' ||   // HMB
        this.userAuth.companyId === '6107163db7c09a18a2663385') {     // Subaru
        reportIndex = obj.prehgsi;
      } else {
        reportIndex = obj.reportIndex;
      }
      let qtd = 0;
      for (let i = 0; i < reportIndex.length; i += 1) {
        if ((reportIndex[i].total > 0 && this.userAuth.companyId !== '6107f837f50c776b205ebf48') ||
          (reportIndex[i].average >= 0 && this.userAuth.companyId === '6107f837f50c776b205ebf48'))
        {
        // if (reportIndex[i].average > 0) {
        //   this.userAuth.companyId === '6107163db7c09a18a2663385') {
          qtd += 1;
         }
        if (this.userAuth.companyId === '6107159a24278234e7bdaea3') { // Ford
          total += parseFloat(reportIndex[i].average);
        } else {
          total += parseInt(reportIndex[i].average);
        }
      }
      if (qtd > 0) {
        if (this.userAuth.companyId === '6107159a24278234e7bdaea3') { // Ford
          return (total / qtd).toFixed(2);
        }
        return (total / qtd).toFixed(0);
      }
      return 0;
    },
    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    exportToXLS() {
      const header = [];
      for (let i = 0; i < this.fields.length; i += 1) {
        header.push(this.fields[i].label);
      }

      const arr = [];

      this.items.forEach((el) => {
        if (this.totalVendas) {
          arr.push({
            'Código': el.codigo,
            'Concessionária': el.concessionaria,
            'Cota Mínima': parseInt(el.cota),
            'Entrevistas realizadas': parseInt(el.entrevistas),
            'Satisfação com o Veículo (%SIM)': parseFloat(el.satisfacao),
            [this.indexLabel]: parseFloat(el.index),
            'NPS': parseFloat(el.nps),
            'Recomendação': parseFloat(el.recomendacao),
            'Oferta Test Drive (%SIM)': parseFloat(el.testDrive),
          });
        } else {
          arr.push({
            'Código': el.codigo,
            'Concessionária': el.concessionaria,
            'Cota Mínima': parseInt(el.cota),
            'Entrevistas realizadas': parseInt(el.entrevistas),
            'Satisfação Geral': parseFloat(el.satisfacao),
            [this.indexLabel]: parseFloat(el.index),
            'NPS': parseFloat(el.nps),
            'Recomendação': parseFloat(el.recomendacao),
            'FRFT (% não)': parseFloat(el.frft),
          });
        }
      });

      const wb = XLSX.utils.book_new();

      wb.SheetNames.push('previa');

      const ws = XLSX.utils.json_to_sheet(arr, { header });

      // eslint-disable-next-line
      wb.Sheets['previa'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'previa-indice.xlsx');
      document.body.appendChild(link);
      link.click();
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    switch (this.userAuth.companyId) {
      case '610714d424278234e7bdae99':  // CAOA CHERY shows CCSI report
        this.reportTitle = 'CCSI - CAOA Chery Satisfaction';
        this.indexLabel = 'CCSI';
        break;
      case '6107163db7c09a18a2663385':  // CAOA SUBARU shows SCSI report
        this.reportTitle = 'SCSI - CAOA Subaru Satisfaction';
        this.indexLabel = 'SCSI';
        break;
      case '5f69ee75a3024a4fa2416b1f':  // CAOA Hyundai shows HGSI report
        this.reportTitle = 'HGSI - CAOA Hyundai Satisfaction';
        this.indexLabel = 'HGSI';
        break;
      case '6107f837f50c776b205ebf48':  // CAOA HMB shows PRE-HGSI report
        this.reportTitle = 'PRE-HGSI - CAOA HMB Satisfaction';
        this.indexLabel = 'PRE-HGSI';
        break;
      case '6107159a24278234e7bdaea3':  // CAOA FORD shows FCSI report
        this.reportTitle = 'FCSI - CAOA Ford Satisfaction';
        this.indexLabel = 'FCSI';
        break;
      default:
        break;
    }
    this.fields = [
      {
        key: 'codigo',
        label: 'Código',
        sortable: true,
      },
      {
        key: 'concessionaria',
        label: 'Concessionária',
        sortable: true,
      },
      {
        key: 'cota',
        label: 'Cota Mínima',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'entrevistas',
        label: 'Entrevistas realizadas',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'satisfacao',
        label: 'Satisfação com o Veículo (%SIM)',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'index',
        label: this.indexLabel,
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'nps',
        label: 'NPS',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'recomendacao',
        label: 'Recomendação',
        sortable: true,
        class: 'text-center',
      },
      {
        key: 'testDrive',
        label: 'Oferta Test Drive (%SIM)',
        sortable: true,
        class: 'text-center',
      },
    ];
  },

  async mounted() {
    this.loading = true;
    await this.getIndexPreview();
    this.loading = false;
  },
};
</script>

<style lang="scss">
#number-cxi {
  font-size: 50px !important;
}
.scoreTh {
  width: 70px;
  padding-right: 0px !important;
}

.questionTh {
  width: calc(100% - 200px);
}
</style>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.board-box {
  width: 10%;
  text-align: left;
  font-size: 16px;
  margin: 0px 20px;
  border: 1px solid #eee;
}
.board-box-value {
  float: right;
  padding-right: 40%;
  font-size: 24px;
}
.nps-display {
  border: none !important;
}
.board-percentil {
  padding: 20px 0px 20px 20px;
  min-width: 150px;
}
.board-percentil-label {
  font-size: 14px;
}
.board-percentil-percent {
  font-size: 20px;
}
.board-percentil-value {
  font-size: 16px;
}
.board-border {
  border: 1px solid #eee;
}
.board-header h1 {
  font-size: 16px;
}
.radial-progress-inner {
  justify-content: center;
  font-size: 3.2em;
  cursor: pointer;
}
.nps-display {
  border: 1px solid $gray-light;
  padding: 18px 0;
  flex-direction: column;
  border-radius: 4px;
  background-color: $white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  .idx-card-title {
    height: 30px;
    padding-left: 20px;
    text-align: left;
    width: 100%;
    font-weight: 100;
    color: #5f6368;
    font-size: 18px;
  }
  .nps-chart {
    display: flex;
    justify-content: center;
    align-items: center;
    height: calc(100% - 30px);
  }
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}

@media (max-width: 1310px) {
  .summary {
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/index-preview/index.vue